<template lang="pug">
div
    el-row(v-if="pessoa && !isSocio", :span="24")
        div.labelStyle(
          v-if="isReurbInteressadoPj || isReurbPJAntigo",
          key="pessoa-juridica-reurb"
        )
          el-col(:span="12")
            app-display(
              id="RAZAO_SOCIAL_REURB_PJ",
              label="Razão social:",
              :content="isReurbPJAntigo ? razaoSocialRequerente : pessoa.pessoaJuridica.razaoSocial",
              :class = "compararInformacoesPessoa.mudouRazaoSocial ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="CNPJ_REURB_PJ",
              label="CNPJ:",
              :content="isReurbPJAntigo ? cnpjRequerente : pessoa.pessoaJuridica.cnpj",
              :class = "compararInformacoesPessoa.mudouCNPJ ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              v-if="pessoa.pessoaJuridica"
              id="CLASSIFICACAO_REURB_PJ",
              label="Classificação:",
              :content="pessoa.pessoaJuridica && pessoa.pessoaJuridica.classificacao ? formatarTexto(pessoa.pessoaJuridica.classificacao):'-'",
            )
        el-col(:span="24" v-if="isReurbInteressadoPj || isReurbPJAntigo")
          app-divider(label="Representante legal")

        div.labelStyle(
          v-if="isPf || isReurbInteressadoPj || isReurbPJAntigo",
          key="pessoa-fisica"
        )
          el-col(:span="12")
            app-display(
              id="NUMERO_CERTIDAO_CASAMENTO",
              label="Número da certidão de casamento:",
              v-if="temCertidaoCasamento"
              :content="pessoaExibicao.certidaoCasamento"
              :class = "compararInformacoesPessoa.mudouNumeroCertidaoCasamento ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="DATA_CASAMENTO",
              label="Data de casamento:",
              v-if="temCertidaoCasamento"
              :content="formatDate(pessoaExibicao.dataCasamento)"
              :class = "compararInformacoesPessoa.mudouDataCasamento ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="NOME_INTERESSADO_CONJUGE",
              :label="temCertidaoCasamento ? 'Cônjuge/Companheiro(a):' : 'Nome:'",
              :content="pessoaExibicao.nome",
              v-if="pessoaExibicao.cpf",
              :class = "compararInformacoesPessoa.mudouNome ? 'text': '' "
            )
          el-col(:span="12" v-if="!isProcessoFisico && !isBancoDados")
            app-display(
              id="APELIDO",
              label="Apelido:",
              :content="pessoaExibicao.apelido ? pessoaExibicao.apelido : '-'",
              :class = "compararInformacoesPessoa.mudouApelido ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="CPF",
              label="CPF:",
              v-if="pessoaExibicao.cpf"
              :content="pessoaExibicao.cpf"
              :class = "compararInformacoesPessoa.mudouCPF ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="DATA_NASCIMENTO",
              label="Data de nascimento:",
              :content="data",
              v-if="!isReurb && data"
              :class = "compararInformacoesPessoa.mudouDataNascimento ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              v-if="isReurb"
              id="DATA_NASCIMENTO_REURB",
              label="Data de nascimento:",
              :content="formatDate(pessoaExibicao.dataNascimento)",
              :class = "compararInformacoesPessoa.mudouDataNascimento ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="SEXO",
              label="Sexo:",
              v-if="pessoaExibicao.sexo && !isReurb"
              :content="formatarTexto(pessoaExibicao.sexo)",
            )
          el-col(:span="12")
            app-display(
              id="SEXO_REURB",
              label="Sexo:",
              v-if="isReurb"
              :content="formatarTexto(pessoaExibicao.sexo)",
            )
          el-col(:span="12")
            app-display(
              id="TEMPO_MORADIA",
              label="Tempo moradia:",
              v-if="pessoaExibicao.tempoMoradia"
              :content="`${pessoaExibicao.tempoMoradia} anos`"
              :class = "compararInformacoesPessoa.mudouTempoMoradia ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="NACIONALIDADE",
              label="Nacionalidade:",
              :content="getGentilico(pessoaExibicao.nacionalidade)",
              v-if="pessoaExibicao.nacionalidade"
              :class = "compararInformacoesPessoa.mudouNacionalidade ? 'text': '' "
            )
          el-col(:span="12" v-if="!isBancoDados")
            app-display(
              id="NATURALIDADE",
              label="Naturalidade:",
              :content="getNaturalidade(pessoaExibicao)",
              v-if="pessoaExibicao.municipio || pessoaExibicao.naturalidade && !isReurb"
              :class = "compararInformacoesPessoa.mudouNaturalidade ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="NATURALIDADE_REURB",
              label="Naturalidade:",
              :content="getNaturalidadeReurb(pessoaExibicao)",
              v-if="isReurb"
              :class = "compararInformacoesPessoa.mudouNaturalidade ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="RG",
              label="RG:",
              :content="pessoaExibicao.rg",
              v-if="pessoaExibicao.rg && !isReurb"
              :class = "compararInformacoesPessoa.mudouRG ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="RG_REURB",
              label="RG:",
              :content="pessoaExibicao.rg ? pessoaExibicao.rg : '-'",
              v-if="isReurb"
              :class = "compararInformacoesPessoa.mudouRG ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="ORGAO_EXPEDIDOR",
              label="Órgão expedidor:",
              :content="getOrgaoExpedidor(pessoaExibicao.orgaoExpedidor)",
              v-if="pessoaExibicao.orgaoExpedidor && !isReurb"
              :class = "compararInformacoesPessoa.mudouOrgaoExpedidor ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="ORGAO_EXPEDIDOR_REURB",
              label="Órgão expedidor:",
              :content="pessoa && pessoaExibicao && pessoaExibicao.orgaoExpedidor ? getOrgaoExpedidor(pessoaExibicao.orgaoExpedidor) : '-'",
              v-if="isReurb"
              :class = "compararInformacoesPessoa.mudouOrgaoExpedidor ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="ORGAO_EXPEDIDOR_DESCRICAO_REURB",
              label="Descrição órgão expedidor:",
              :content="pessoa && pessoaExibicao && pessoaExibicao.descricaoOrgaoExpedidor ? getDescricaoOrgaoExpedidor(pessoaExibicao.descricaoOrgaoExpedidor, pessoaExibicao.orgaoExpedidor) : '-'",
              v-if="isReurb && pessoaExibicao.descricaoOrgaoExpedidor"
              :class = "compararInformacoesPessoa.mudouOrgaoExpedidor ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="ESTADO_CIVIL_BANCO_DADOS",
              label="Estado civil:",
              :content="getEstadoCivil(pessoaExibicao.estadoCivil)"
              v-if="isBancoDados && pessoaExibicao.estadoCivil"
            )
          el-col(:span="12")
            app-display-multiple(
              id="TELEFONES",
              label="Telefone(s):"
              :content="formatTelefone(pessoa.telefones)"
              v-if="!isConjuge"
              :class = "compararInformacoesPessoa.mudouTelefones ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="EMAIL_INTERESSADO",
              label="E-mail:"
              :content="getEmail(pessoa.email)"
              v-if="!isConjuge && !isProcessoFisico && !isBancoDados"
              :class = "compararInformacoesPessoa.mudouEmail ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="PROFISSAO",
              label="Profissão:"
              v-if="!isReurb && pessoaExibicao.profissao"
              :content="pessoaExibicao.profissao",
            )
          el-col(:span="12")
            app-display(
              id="PROFISSAO_REURB",
              label="Profissão:"
              v-if="isReurb && pessoaExibicao.profissao"
              :content="pessoaExibicao.profissao",
            )
          el-col(:span="12")
            app-display(
              id="NOME_MAE",
              label="Nome da mãe:",
              :content="pessoaExibicao.nomeDaMae",
              v-if="pessoaExibicao.nomeDaMae && !isReurb"
              :class = "compararInformacoesPessoa.mudouNomeDaMae ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="NOME_MAE_REURB",
              label="Nome da mãe:",
              :content="pessoaExibicao.nomeDaMae ? pessoaExibicao.nomeDaMae : '-'",
              v-if="isReurb && !isConjuge"
              :class = "compararInformacoesPessoa.mudouNomeDaMae ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="NOME_PAI",
              label="Nome do pai:",
              :content="pessoaExibicao.nomeDoPai",
              v-if="pessoaExibicao.nomeDoPai && !isReurb"
              :class = "compararInformacoesPessoa.mudouNomeDoPai ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="NOME_PAI_REURB",
              label="Nome do pai:",
              :content="pessoaExibicao.nomeDoPai ? pessoaExibicao.nomeDoPai : 'Sem registro'",
              v-if="isReurb && !isConjuge && !pessoaExibicao.paiNaoRegistrado"
              :class = "compararInformacoesPessoa.mudouNomeDoPai ? 'text': '' "
            )
            app-display(
              v-if="pessoaExibicao.paiNaoRegistrado"
              id="PAI_NAO_REGISTRADO_REURB",
              label="Nome do pai:",
              content="Não registrado",
              :class = "compararInformacoesPessoa.paiNaoRegistrado ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="RENDA",
              label="Renda:",
              :content="formatRenda (membroFamilia.rendaMembro)",
              v-if="isReurb && membroFamilia && membroFamilia.rendaMembro"
              :class = "compararRendaFamiliar ? 'text' :  '' "
            )
          el-col(:span="12")
            app-display(
              id="PROGRAMA_SOCIAL",
              label="Programa social:",
              :content="membroFamilia && membroFamilia.programaSocial ? membroFamilia.programaSocial : '-'",
              v-if="isReurb"
            )
          el-col(:span="12")
            app-display(
              id="OBSERVACOES_RENDA",
              label="Observações referentes à renda:",
              :content="membroFamilia && membroFamilia.observacoesRenda ? membroFamilia.observacoesRenda : '-'"
              v-if="isReurb"
            )
          el-col(:span="12")
            app-display(
              id="ESTADO_CIVIL",
              label="Estado civil:",
              :content="getEstadoCivil(estadoCivilExibicao)"
              v-if="isReurb && estadoCivilExibicao"
            )
          el-col(:span="12")
            app-display(
              id="SEPARACAO_FATO",
              label="Separação de fato:",
              :content="pessoaExibicao.separacaoFato ? 'Sim': 'Não'"
              v-if="isReurb && pessoaExibicao.separacaoFato != null"
            )
          el-col(:span="12" v-if="isProcessoFisico")
            app-display(
              id="TIPO_DOCUMENTO",
              label="Tipo de documento:",
              :content="pessoaExibicao.tipoDocumento || '-'"
            )
          el-col(:span="12" v-if="isProcessoFisico")
            app-display(
              id="OUTROS",
              label="Outros:",
              :content="pessoaExibicao.outrosTipoDocumento",
              v-if="pessoaExibicao.tipoDocumento == 'OUTROS'"
            )
          el-col(:span="12")
            app-display(
              id="POSSUI_FILHO_MENOR",
              label="Possui filho menor de 16 anos:",
              :content="pessoaExibicao.filhoMenorDe16 ?  'Sim' : 'Não'",
              v-if="pessoaExibicao.filhoMenorDe16 === true || pessoaExibicao.filhoMenorDe16 === false"
            )
          el-col(:span="12")
            app-display(
              id="RENDA_FAMILIAR",
              label="Renda familiar:",
              :content="rendaFamiliar.includes('R$') ? rendaFamiliar : `R$ ${rendaFamiliar}`",
              v-if="rendaFamiliar"
              :class = "compararRendaFamiliar ? 'text' :  '' "
            )
        div(
          v-if="!isPf && !isReurb",
          key="pessoa-juridica"
        )
          el-row(:span="24")
            el-col(:span="12")
              app-display(
                id="CNPJ_PJ",
                label="CNPJ:",
                :content="pessoa.pessoaJuridica.cnpj"
                :class = "compararInformacoesPessoa.mudouCNPJ ? 'text': '' "
              )
            el-col(:span="12")
              app-display(
                id="RAZAO_SOCIAL_PJ",
                :label="razaoSocialName",
                :content="pessoa.pessoaJuridica.razaoSocial"
                :class = "compararInformacoesPessoa.mudouRazaoSocial ? 'text': '' "
              )
            el-col(:span="12" v-if="!isProcessoFisico")
              app-display-multiple(
                id="TELEFONES_PJ",
                label="Telefone(s):"
                :content="pessoa.telefones"
                :class = "compararInformacoesPessoa.mudouTelefones ? 'text': '' "
              )
            el-col(:span="12" v-if="!isProcessoFisico")
              app-display(
                id="EMAIL_PJ",
                label="E-mail:",
                :content="pessoa.email",
                v-if="!isConjuge"
                :class = "compararInformacoesPessoa.mudouEmail ? 'text': '' "
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                id="NOME_PRESIDENTE_PJ",
                label="Nome do presidente da associação/empresa:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.nome",
                v-if="!isConjuge"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                id="CPF_PRESIDENTE_PJ",
                label="CPF do presidente da associação/empresa:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.cpf",
                v-if="!isConjuge"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                id="RG_PRESIDENTE_PJ",
                label="RG do presidente da associação/empresa:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.rg || '-'",
                v-if="!isConjuge"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                id="TIPO_DOCUMENTO_PJ",
                label="Tipo de documento:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.tipoDocumento || '-'",
                v-if="!isConjuge"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                id="OUTROS_PJ",
                label="Outros:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.outrosTipoDocumento || '-'",
                v-if="!isConjuge && pessoa.pessoaJuridica.presidenteAssociacao.tipoDocumento == 'OUTROS'"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                id="ORGAO_EXPEDIDOR_PJ",
                label="Órgão expedidor:",
                :content="getOrgaoExpedidor(pessoa.pessoaJuridica.presidenteAssociacao.orgaoExpedidor)",
                v-if="!isConjuge"
              )
    el-row(v-if="pessoa && isSocio", :span="24")
        div(
          v-if="pessoa.pessoa.isPessoaFisica",
          key="pessoa-fisica"
        )
          el-col(:span="12")
            app-display(
              id="NOME_SOCIO",
              label="Nome:",
              :content="pessoa.pessoa.pessoaFisica.nome"
              :class = "compararInformacoesPessoa.mudouNome ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="CPF_SOCIO",
              label="CPF:",
              :content="pessoa.pessoa.pessoaFisica.cpf"
              :class = "compararInformacoesPessoa.mudouCPF ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="RG_SOCIO",
              label="RG:",
              :content="pessoa.pessoa.pessoaFisica.rg",
              v-if="pessoa.pessoa.pessoaFisica.rg"
              :class = "compararInformacoesPessoa.mudouRG ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="FUNCAO_SOCIO",
              label="Função:",
              :content="getFuncao(pessoa.funcao)",
              v-if="pessoa.funcao"
            )
          el-col(:span="12")
            app-display(
              id="NACIONALIDADE_SOCIO",
              label="Nacionalidade:",
              :content="getGentilico(pessoa.pessoa.pessoaFisica.nacionalidade)",
              v-if="pessoa.pessoa.pessoaFisica.nacionalidade"
              :class = "compararInformacoesPessoa.mudouNacionalidade ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="EMAIL_SOCIO",
              label="E-mail:",
              :content="pessoa.pessoa.email",
              v-if="pessoa.pessoa.email"
              :class = "compararInformacoesPessoa.mudouEmail ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="ESTADO_CIVIL_SOCIO",
              label="Estado civil:",
              :content="getEstadoCivil(pessoa.pessoa.pessoaFisica.estadoCivil)"
              :class = "compararInformacoesPessoa.mudouEstadoCivil ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="DATA_NASCIMENTO_SOCIO",
              label="Data de nascimento:",
              :content="data",
              v-if="data"
              :class = "compararInformacoesPessoa.mudouDataNascimento ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="ORGAO_EXPEDIDOR_SOCIO",
              label="Órgão expedidor:",
              :content="getOrgaoExpedidor(pessoa.pessoa.pessoaFisica.orgaoExpedidor)",
              v-if="pessoa.pessoa.pessoaFisica.orgaoExpedidor"
              :class = "compararInformacoesPessoa.mudouOrgaoExpedidor ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="NATURALIDADE_SOCIO",
              label="Naturalidade:",
              :content="getNaturalidade(pessoa.pessoa.pessoaFisica)",
              v-if="pessoa.pessoa.pessoaFisica.municipio"
              :class = "compararInformacoesPessoa.mudouNaturalidade ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="REPRESENTANTE_LEGAL_SOCIO",
              label="O sócio é representante legal?",
              :content="pessoa.isSocioRepresentanteLegal ? 'Sim' : 'Não'",
              v-if="pessoa.isSocioRepresentanteLegal !== null && pessoa.isSocioRepresentanteLegal !== ''"
              :class = "compararIsSocioRepresentanteLegal ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              id="NOME_MAE_SOCIO",
              label="Nome da mãe:",
              :content="pessoa.pessoa.pessoaFisica.nomeDaMae",
              v-if="pessoa.pessoa.pessoaFisica.nomeDaMae"
              :class = "compararInformacoesPessoa.mudouNomeDaMae ? 'text': '' "
            )
          el-col(:span="12")
            app-display-multiple(
              label=":"
              :content="pessoa.pessoa.telefones"
              :class = "compararInformacoesPessoa.mudouTelefones ? 'text': '' "

            )
        div(
          v-if="!pessoa.pessoa.isPessoaFisica && !isReurb",
          key="pessoa-juridica"
        )
          el-row(:span="24")
            el-col(:span="12")
              app-display(
                id="CNPJ",
                label="CNPJ:",
                :content="pessoa.pessoa.pessoaJuridica.cnpj"
                :class = "compararInformacoesPessoa.mudouCNPJ ? 'text': '' "

              )
            el-col(:span="12")
              app-display(
                id="RAZAO_SOCIAL",
                :label="razaoSocialName",
                :content="pessoa.pessoa.pessoaJuridica.razaoSocial"
                :class = "compararInformacoesPessoa.mudouRazaoSocial ? 'text': '' "
              )
            el-col(:span="12")
              app-display-multiple(
                id="TELEFONES",
                label="Telefone(s):"
                :content="pessoa.pessoa.telefones"
                :class = "compararInformacoesPessoa.mudouTelefones ? 'text': '' "

              )
            el-col(:span="12")
              app-display(
                id="EMAIL",
                label="E-mail:",
                :content="pessoa.email",
                v-if="!isConjuge"
                :class = "compararInformacoesPessoa.mudouEmail ? 'text': '' "
              )
</template>

<script>

import moment from 'moment'
import AppDisplay from '@/components/AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import AppDivider from '@/components/AppDivider.vue'
import gentilicos from '@/constants/gentilico'
import orgaosExpedidores from '@/constants/orgaosExpedidores'
import estados from '@/constants/estados'
import compararReticacoesDefault from '../../../utils/pa/compararReticacoesDefault'
import utils from '@/utils/utils'

export default {

  components: {
    AppDisplay,
    AppDisplayMultiple,
    AppDivider
  },

  props: {
    pessoa: {
      type: Object,
      default: () => {}
    },
    isConjuge: {
      type: Boolean,
      default: false
    },
    razaoSocialName: {
      type: String,
      default: 'Razão Social'
    },
    isSocioRepresentanteLegal: {
      type: Boolean,
      default: false
    },
    pessoaSocio: {
      type: Object,
      required: false
    },
    isSocio: {
      type: Boolean,
      required: false,
      default: false
    },
    rendaFamiliar: {
      type: String,
      required: false
    },
    compararInformacoesPessoa: {
      type: Object,
      default: compararReticacoesDefault.mudouPessoaDefault
    },
    compararIsSocioRepresentanteLegal: {
      type: Boolean,
      default: false
    },
    compararRendaFamiliar: {
      type: Boolean,
      default: false
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    },
    isBancoDados: {
      type: Boolean,
      required: false,
      default: false
    },
    isReurb: {
      type: Boolean,
      required: false,
      default: false
    },
    membroFamilia: {
      type: Object,
      required: false,
      default: () => {}
    },
    cnpjRequerente: {
      type: String,
      required: false
    },
    razaoSocialRequerente: {
      type: String,
      required: false
    }
  },

  computed: {

    isPf () {
      return this.pessoa.isPessoaFisica || ['PF', 'PESSOA_FISICA'].includes(this.pessoa.tipo)
    },

    isReurbPJAntigo () {
      return this.isReurb && !!this.cnpjRequerente && !this.isConjuge
    },

    isReurbInteressadoPj () {
      return this.isReurb && !this.isPf && this.pessoa.tipo === 'PJ'
    },

    pessoaExibicao () {
      if (this.isReurbInteressadoPj) {
        return this.pessoa.pessoaJuridica.representanteLegal || {}
      }
      return this.pessoa.pessoaFisica || {}
    },

    data () {
      if (this.isSocio && this.pessoa.pessoa.pessoaFisica.dataNascimento) {
        return moment(this.pessoa.pessoa.pessoaFisica.dataNascimento).format('DD/MM/YYYY')
      }
      if (!this.isSocio && this.pessoaExibicao.dataNascimento) {
        return moment(this.pessoaExibicao.dataNascimento).format('DD/MM/YYYY')
      }
    },

    temCertidaoCasamento () {
      return this.pessoaExibicao?.certidaoCasamento
    },

    estadoCivilExibicao () {
      return (this.membroFamilia && this.membroFamilia.estadoCivil) || this.pessoaExibicao.estadoCivil
    }
  },

  methods: {
    getGentilico (sigla) {
      return gentilicos.filter(item => item.sigla === sigla)[0].gentilico
    },
    getNaturalidade (pessoa) {
      if (pessoa.municipio) {
        return pessoa.municipio.nome + ' - ' + pessoa.municipio.estadoCod
      } else {
        return pessoa.naturalidade.nome + ' - ' + pessoa.naturalidade.codigoEstado
      }
    },
    getNaturalidadeReurb (pessoa) {
      if (pessoa?.naturalidade?.nome && pessoa?.naturalidade?.codigoEstado) {
        return pessoa.naturalidade?.nome + ' - ' + pessoa.naturalidade.codigoEstado
      } else {
        return '-'
      }
    },

    formatDate (date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return '-'
      }
    },
    getEmail (email) {
      return email || '-'
    },
    getFuncao (funcao) {
      if (funcao === 'SOCIO') return 'Sócio'
      if (funcao === 'REPRESENTANTE') return 'Representante'
      if (funcao === 'DIRETOR') return 'Diretor'
    },
    getOrgaoExpedidor (orgao) {
      if (orgao?.codigo === 'OUTROS') {
        return orgao.nome
      }

      if (!orgao || !orgao.codigo) {
        return '-'
      }

      const estado = orgao.estado
        ? estados.find(item => item.codigo === orgao.estado)
        : null

      if (this.isBancoDados && estado) {
        return orgao.codigo + ' - ' + estado.codigo
      }

      if (estado) {
        const orgaoNome = orgaosExpedidores().find(item => item.codigo === orgao.codigo)?.name
        return orgaoNome + ' - ' + estado.nome
      }

      return orgao.codigo
    },
    getDescricaoOrgaoExpedidor (descricaoOrgao, orgao) {
      const estado = orgao?.estado
        ? estados.find(item => item.codigo === orgao.estado)
        : null

      if (estado) {
        return `${descricaoOrgao} ${estado.nome}`
      }

      return descricaoOrgao
    },
    getEstadoCivil (props) {
      if (props === null) return '-'
      if (props === 'SOLTEIRO') return 'Solteiro'
      if (props === 'CASADO') return 'Casado'
      if (props === 'DIVORCIADO') return 'Divorciado'
      if (props === 'SEPARADO') return 'Separado'
      if (props === 'UNIAO_ESTAVEL') return 'União Estável'
      if (props === 'UNIAO_HOMOAFETIVA') return 'União Homoafetiva'
      if (props === 'VIUVO') return 'Viúvo'

      return props
    },
    formatTelefone (telefones) {
      if (telefones && telefones.length) {
        return telefones.map(telefone => {
          if (telefone?.numero) {
            return telefone.numero
          } else {
            return telefone
          }
        })
      }
      return ['Nenhum telefone registrado']
    },
    formatarTexto (texto) {
      if (texto) {
        return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase()
      } else {
        return '-'
      }
    },
    formatRenda (valor) {
      return utils.padraoMoedaBrasil.format(valor)
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    margin-bottom: 1vh;
    font-size: 14px;
    b {
      span{
        font-weight: normal !important;
      }
    }
  }
  >>> .text .text{
    color: #ff0000 !important;
  }

  @media (max-width: 780px) {
    .labelStyle {
      display: flex;
      flex-direction: column;
      width: 490px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/ma/InformacoesPessoa.vue